import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useGetQuery } from 'hooks'
import { Card, Icon, PaginateTable, Row } from 'components'

export const AdminDungeons = () => {
  const [page, setPage] = useState({ page: 1, limit: 25 })
  const navigate = useNavigate()
  const offset = (page.page - 1) * page.limit

  const { data, isFetching } = useGetQuery({
    url: `/admin/dungeons?limit=${page.limit}&offset=${offset}`,
  })

  const dungeons = data?.dungeons?.rows ?? []
  const count    = data?.dungeons?.count ?? 0

  return (
    <Card>
      <Row>
        <PaginateTable
          data={dungeons}
          count={count}
          loading={isFetching}
          columns={[
            { title: 'Name',   key: 'name' },
            { title: 'Slug',   key: 'slug' },
            { title: 'Radius', key: 'radius', render: (r) => r ? `${r}m` : '—' },
            {
              title: 'Actions',
              key: 'slug',
              className: 'right',
              render: (slug) => (
                <>
                  <Link to={`/games/dungeon/${slug}/edit`} style={{ marginRight: '0.75rem' }}>
                    <Icon icon="map" />
                  </Link>
                  <Link to={`/admin/dungeons/${slug}/edit`}>
                    <Icon icon="pencil" />
                  </Link>
                </>
              ),
            },
          ]}
          addItem={() => navigate('/admin/dungeons/new')}
          onPageChange={setPage}
        />
      </Row>
    </Card>
  )
}
